// SPDX-License-Identifier: AGPL-3.0-or-later

import {isNativeMobileShell} from '@app/features/platform/native_mobile/NativeMobileBridge';
import {
	isIOSMobileOrTabletUserAgent,
	isMobileOrTabletUserAgent,
} from '@app/features/platform/notifications/NotificationAlertOptions';
import {isElectron} from '@app/features/ui/utils/NativeUtils';

interface NavigatorWithStandalone extends Navigator {
	standalone?: boolean;
}

// KONVO: the iOS/Android shell counts as an installed app: same full-screen
// layout, safe areas and keyboard handling as the home-screen PWA.
export function isStandalonePwa(): boolean {
	if (isNativeMobileShell()) return true;
	const matchDisplayMode = window.matchMedia?.('(display-mode: standalone)').matches ?? false;
	const navigatorStandalone = (window.navigator as NavigatorWithStandalone).standalone === true;
	const androidReferrer = document.referrer.includes('android-app://');
	return matchDisplayMode || navigatorStandalone || androidReferrer;
}

export function isMobileOrTablet(): boolean {
	return isMobileOrTabletUserAgent(navigator.userAgent, navigator.maxTouchPoints);
}

export function isInstalledIOSPwa(): boolean {
	return (
		isStandalonePwa() && isIOSMobileOrTabletUserAgent(navigator.userAgent, navigator.maxTouchPoints) && !isElectron()
	);
}

export function isPwaOnMobileOrTablet(): boolean {
	return isStandalonePwa() && isMobileOrTablet();
}

export function isInstalledPwa(): boolean {
	return isStandalonePwa() && !isElectron();
}
